import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import store, { persistor } from './store';
import GlobalStyle from './styles/GlobalStyle';
import AppRoutes from './routes';
import history from './services/history';
import { ToastContainer } from 'react-toastify';
import Loading from './components/Loading';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <AppRoutes />
          <GlobalStyle />
          <Loading />
          <ToastContainer autoClose={3000} className="toast-container" />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
